export default __webpack_public_path__ + "static/media/DOC.00fa948b.svg";